<template>
  <div>
    <a-card title="添加活动" :bordered="false">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="活动名称"
        >
          <a-input
            v-decorator="[
          'name',
          {rules: [{ required: true, message: '必填项' }]}
        ]"
            placeholder="活动名称"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="活动时间"
        >
          <a-range-picker
            style="width: 100%"
            @change="onDateChange"
            v-decorator="[
              'dateRange',
              {rules: [{ required: true, message: '请选择生效日期'}]}
            ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="说明"
        >
          <a-input v-decorator="[
          'note'
        ]" placeholder="说明"/>
        </a-form-item>

        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
          <div>
            <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
            <a-button @click="goBack">取消</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
import moment from "moment";
export default {
  name: "eventAdd",
  created() {},
  data() {
    return {
      startTime: "",
      endTime: "",
      endOpen: false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        console.log(values);
        if (!err) {
          values["startTime"] = this.startTime;
          values["endTime"] = this.endTime;
           console.log(values);
          this.$http.post("/api/1.0/event/save", values).then(res => {
            this.$http.ajaxResultDue(res, "/event", null);
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    moment,
    onDateChange(dates, dateStrings) {
      this.startTime = dateStrings[0];
      this.endTime = dateStrings[1];
    }
  }
};
</script>
<style scoped>
.ant-input-number {
  width: 100%;
}
</style>

